import { funlidayRequest } from './main';
import { getClientId } from '../utilities/uuid_util';

/**
 * @methods getPublicCollections - 取得公開收藏資料
 * @param {String} folderID (Required)網址上帶入的 Collections folderID
 * @param {object} signal (Optional)透過 signal 可在外部呼叫時終止 AJAX
 * @returns {Promise} axiosPromise
 */
export const getPublicCollections = (folderID, signal) => {
  const body = {
    folderId: folderID,
  };
  const headers = {};
  if (signal) headers.cancelToken = signal.token;
  return funlidayRequest.post(`/getPublicCollections`, body, headers);
};

/**
 * @methods addCollection - 將景點加入收藏
 * @param {Object} param (Required) paramObject
 * @description legacy API，之後勢必還會更改，大量參數請直接見文件..
 * @see http://114.32.168.43:5566/funliday/index.html#api-Collections
 * @returns {Promise} axiosPromise
 */
export const addCollection = param => {
  return funlidayRequest.post(`/addCollection`, param);
};

/** 建立新景點收藏資料夾
 * @param {string} folderName - (Required) folder name
 * @returns {Promise} axiosPromise
 */
export const createCollectionsFolder = folderName => {
  const params = {
    deviceId: getClientId(),
    folderName,
  };
  return funlidayRequest.post(`/createCollectionsFolder`, params);
};

/** 刪除收藏景點
 * @param {string} idArray - (Required) 欲刪除之 poi id 陣列
 * @param {string} folderId - (Optional) 欲刪除之 poi id 所在資料夾
 * @returns {Promise} axiosPromise
 */
export const deleteCollections = (idArray, folderId) => {
  const params = {
    deviceId: getClientId(),
    idArray,
  };
  if (folderId) {
    params.collectionsFolderObjectId = folderId;
  }
  return funlidayRequest.post(`/deleteCollections`, params);
};

/** 刪除收藏景點資料夾
 * @param {string} collectionsFolderObjectId - (Required) 欲刪除之景點資料夾
 * @returns {Promise} axiosPromise
 */
export const deleteCollectionsFolder = collectionsFolderObjectId => {
  const params = {
    deviceId: getClientId(),
    collectionsFolderObjectId,
  };
  return funlidayRequest.post(`/deleteCollectionsFolder`, params);
};

/** 移動收藏景點
 * @param {string} idArray - (Required) 欲移動之 poi id 陣列
 * * @param {string} toFolderId - (optional) 欲移動之資料夾 id
 * * @param {string} fromFolderId - (optional) 欲從哪個資料夾 id 移動
 * @returns {Promise} axiosPromise
 */
export const moveCollectionsToFolder = (idArray, toFolderId, fromFolderId) => {
  const params = {
    deviceId: getClientId(),
    idArray,
    toCollectionsFolderObjectId: toFolderId,
  };
  if (fromFolderId) {
    params.fromCollectionsFolderObjectId = fromFolderId;
  }
  return funlidayRequest.post(`/moveCollectionsToFolder`, params);
};

/** 複製收藏景點
 * @param {string} idArray - (Required) 欲移動之 poi id 陣列
 * * @param {string} toFolderId - (optional) 欲移動之資料夾 id
 * * @param {string} fromFolderId - (optional) 欲從哪個資料夾 id 移動
 * @returns {Promise} axiosPromise
 */
export const copyCollectionsToFolder = (idArray, toFolderId, fromFolderId) => {
  const params = {
    deviceId: getClientId(),
    idArray,
    toCollectionsFolderObjectId: toFolderId,
  };
  if (fromFolderId) {
    params.fromCollectionsFolderObjectId = fromFolderId;
  }
  return funlidayRequest.post(`/copyCollectionsToFolder`, params);
};

/** 獲取景點資料夾
 * @param {string} skip - (Required) 欲開始獲取的索引值
 * * @param {string} limit - (Required) 獲取的數量
 * @returns {Promise} axiosPromise
 */
export const getCollectionsFolderList = (skip, limit) => {
  const params = {
    deviceId: getClientId(),
    skip: skip.toString(),
    limit: limit.toString(),
  };
  return funlidayRequest.post(`/getCollectionsFolderList`, params);
};

/** 更新景點別名
 * @param {string} poiId - (Required) 欲更新 poi id
 * * @param {string} aliasName - (Required) 景點別名
 * * @param {string} folderId - (optional) 景點所在資料夾 id
 * @returns {Promise} axiosPromise
 */
export const editAliasNameOfCollection = (
  poiId,
  aliasName,
  folderId = null,
) => {
  const params = {
    deviceId: getClientId(),
    parsePoiObjectId: poiId,
    aliasName,
  };

  if (folderId) {
    params.collectionsFolderObjectId = folderId;
  }
  return funlidayRequest.post(`/editAliasNameOfCollection`, params);
};

/** 更新景點資料夾名稱
 * @param {string} folderId - (optional) 景點資料夾 id
 * * @param {string} folderName - (Required) 欲更新景點資料夾名稱
 * @returns {Promise} axiosPromise
 */
export const updateFolderInfo = (folderId, folderName) => {
  const params = {
    deviceId: getClientId(),
    collectionsFolderObjectId: folderId,
    folderName,
  };

  return funlidayRequest.post(`/updateFolderInfo`, params);
};
